import React, { Component } from 'react';
import LaddaButton from 'react-ladda';
import Formsy, { Form } from 'formsy-react';
import FormGroup from './FormGroup';
import { Input, Textarea } from 'formsy-react-components';
import Message from './Message';

import '!style!css!postcss!ladda/dist/ladda-themeless.min.css';

class ContactForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      canSubmit: false,
      message: "",
      messageClass: "",
      formIsVisible: ""
    };
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  enableButton() {
    this.setState({
      canSubmit: true
    });
  }

  disableButton() {
    this.setState({
      canSubmit: false
    });
  }

  handleSubmit(data) {
    this.setState({
      loading: true
    })
    fetch('https://hap-backend.herokuapp.com/api/enquiries', {
      headers: {
      "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify(data)
    })
    .then((response) => {
      console.log("success", response);
      this.setState({
        message: 'Enquiry successfully sent',
        messageClass: 'alert-success',
        formIsVisible: 'hidden',
        loading: false
      })
    })
    .catch((error) => {
      console.log("error", error);
      this.setState({
        message: `There was an issue sending the enquiry. ${error.message}`,
        messageClass: 'alert-danger',
        formIsVisible: '',
        loading: false
      })
    })
  }

  render() {
    let state = this.state;
    return (
      <div id="contact-form">
        <Message messageClass={ state.messageClass } message={ state.message } />
        <div id="form" className={ state.formIsVisible }>
          <Formsy.Form
            onValidSubmit={ this.handleSubmit }
            onValid={ this.enableButton }
            onInvalid={ this.disableButton }
          >
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Input
                    layout="vertical"
                    label="Full Name"
                    name="name"
                    id="name"
                    htmlFor="name"
                    validations="isSpecialWords"
                    validationError="Please only use Letters for your Name"
                    placeholder="Full name"
                    required
                  />
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Input
                    layout="vertical"
                    label="Email address"
                    name="email"
                    id="email"
                    validations="isEmail"
                    validationError="This is not a valid Email"
                    placeholder="Email address"
                    type="email"
                    required
                  />
                </FormGroup>
              </div>
              <div className="col-md-2">
                <FormGroup>
                  <Input
                    layout="vertical"
                    label="Postcode"
                    name="postcode"
                    id="postcode"
                    validations="isNumeric,isLength:4"
                    validationError="That is not a valid Australian Postcode"
                    placeholder="Postal Code"
                    required
                  />
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Textarea
                    layout="vertical"
                    label="Message"
                    name="message"
                    id="enqMessage"
                    placeholder="Message"
                    rows={3}
                    required
                  >
                  </Textarea>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2 col-md-offset-10">
                <LaddaButton
                  buttonStyle="zoom-in"
                  loading={ state.loading }
                  disabled={ !state.canSubmit }
                  className="btn btn-hero btn-block"
                  type="submit"
                >
                  Submit
                </LaddaButton>
              </div>
            </div>
          </Formsy.Form>
        </div>
      </div>
    )
  }
}

export default ContactForm;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/ContactForm.jsx
 **/